<template>

  <div class="pc-page">
    <div class="test_main test_main_2">
      <Nav></Nav>
      <div class="test_step clearfix">
        <router-link to="/learningAbility/learningPotential/guide/7" class="button">Part A</router-link>
      </div>
      <div class="test_test clearfix">
        <div class="test_test_l">
          <div class="titbox center">
            <h4 class="cn_tit">语言能力</h4>
            <h6 class="en_tit">Linguisitic</h6>
          </div>
          <div class="desc">
            <p>
              语言能力包括词汇的辨别，语序的推理等。语言能力强有利于你的写作、表达和人际交往。
            </p>
          </div>
          <div class="notice">
            提示：点击“Part A”进入测试！
          </div>
        </div>
        <div class="test_test_r">
          <img src="~@/assets/07.png" alt="" class="img"/>
        </div>
      </div>
    </div>
  </div>

  <!--<div class="d-relative xgtz-index xgtx-ques">-->
  <!--<img class="block-img" src="../../assets/rzqn/index-bg.jpg" alt="">-->
  <!--<img class="block-img rzqn-block-img" src="../../assets/rzqn/i8.png" alt="">-->
  <!--<Nav></Nav>-->
  <!--<div class="evalu-part">-->
  <!--<router-link to="/rzqn/guide/7">-->
  <!--<img src="../../assets/rzqn/partA-1.png" alt="">-->
  <!--</router-link>-->
  <!--</div>-->

  <!--<div class="xgtz-intro rzqn-intro">-->
  <!--<img src="../../assets/rzqn/intro-bg.png" alt="">-->
  <!--<div class="i-desc">-->
  <!--<p>-->
  <!--语言能力包括词汇的辨别，语序的推理等。语言能力强有利于你的写作、表达和人际交往。-->
  <!--</p>-->
  <!--</div>-->
  <!--<div class="i-tip rzqn-tip">-->
  <!--提示：点击“Part A”进入测试！-->
  <!--</div>-->
  <!--</div>-->


  <!--</div>-->
</template>

<script>
  import Nav from '../../../../components/learningAbility/learningPotential.vue';

  export default {
    data() {
      return {}
    },
    mounted() {
      $('.test_menu .item').eq(6).addClass('item_2');
    },
    updated() {

    },
    components: {Nav},
  }
</script>

<style>
  .evalu-nav {
    background: #333;
    opacity: 1;
  }
</style>
